import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAuth } from "react-oidc-context"
import { useT } from "../lib/i18n"

export function LoginCallback() {
  const auth = useAuth()
  const navigate = useNavigate()
  const { t } = useT()

  // react-oidc-context exchanges the ?code/&state params on mount and flips
  // isLoading→false (isAuthenticated→true on success). history.replaceState in
  // onSigninCallback does NOT notify React Router, so without an explicit
  // navigate the app stays stuck on this screen. Once the exchange settles,
  // route to "/": authenticated users land on the home page; otherwise the
  // ProtectedRoute there re-triggers the sign-in redirect.
  useEffect(() => {
    if (!auth.isLoading && !auth.error) {
      navigate("/", { replace: true })
    }
  }, [auth.isLoading, auth.error, navigate])

  if (auth.error) {
    return <main style={{ padding: 40 }}>
      <p>{t("login_failed")}: {auth.error.message}</p>
    </main>
  }
  return <main style={{ padding: 40, color: "var(--muted)" }}>
    {t("login_complete")}
  </main>
}
